import { Box, SelectChangeEvent, Typography } from '@mui/material'
import React from 'react'
import { InvestorLineChatProps } from '../type'
import FilterDropDown from './FilterDropDown'
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";


const InvestorLineChat = (props: InvestorLineChatProps) => {

    const { options, isLoading, defaultValue, filterHandleChange, chartOption } = props

    return (
        <Box padding={'30px'} >
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant='h2'>Number of Investors</Typography>
                <FilterDropDown options={options} isLoading={isLoading} defaultValue={defaultValue} handleChange={filterHandleChange} />
            </Box>
            <Box paddingTop={'35px'}>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={chartOption}
                />
            </Box>
        </Box>
    )
}

export default InvestorLineChat

